<template>
    <div class="lesson_loading">
        <i @click="back"></i>
        <div class="loading" v-if="status == 'loading'">
            <div class="loading-img"></div>
            <p>加载中...</p>
        </div>
        <div class="loading" v-if="status == 'empty'">
            <div class="loading-img-empty"></div>
            <p class="loading-text">暂无对应课程</p>
        </div>
        <div class="loading" v-if="status == 'error'">
            <div class="loading-img-error"></div>
            <p class="loading-text">您的网络好像不稳定</p>
            <p class="loading-text">请稍后再试</p>
            <div class="reload_btn" @click="reload">重新加载</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "lesson_loading",
        props: ['status'],
        data (){
            return {}
        },
        methods: {
            reload: function () {
                window.location.reload()
            },
            back: function() {
                window.location = 'hybird://method/exit'
            }
        },
        created: function () {
        }
    }
</script>

<style lang="scss" scoped>
    .lesson_loading {
        text-align: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100vh;
        z-index: 9999;
        background: #fff;
        overflow: hidden;
        i{
            display: block;
            width: .48rem;
            height: .48rem;
            position: absolute;
            left: .3rem;
            top: .2rem;
            background: url("../../../assets/images/back.png") 0 0/cover no-repeat;
        }
        .loading{
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            display: inline-block;
            margin: 0 auto;
            width: 3.2rem;
            transform: translateY(-50%);
            &-img{
                background: url("../../../assets/images/common/shu.gif") 0 0/1.28rem 1.28rem no-repeat;
                width: 1.28rem;
                height: 1.28rem;
                margin: 0 auto;
            }
            &-img-error{
                background: url("../../../assets/images/common/lesson_error.png") 0 0/2.79rem 2.6rem no-repeat;
                width: 2.79rem;
                height: 2.6rem;
                margin: 0 auto;
            }
            &-img-empty{
                background: url("../../../assets/images/common/lesson_empty.png") 0 0/3.15rem 2.86rem no-repeat;
                width: 3.15rem;
                height: 2.86rem;
                margin: 0 auto;
            }
            p{
                text-align: center;
                font-size: 0.32rem;
                color: #8487a0;
                margin-top: 0.3rem;
                i{
                    font-size: .24rem;
                    color: #8487a0;
                }
            }
        }
    }
    .loading-text {
        text-align: center;
        font-size: 0.32rem;
        color: #8487a0;
    }
    .reload_btn{
        margin-top: .94rem;
        width: 2.4re,;
        height: .88rem;
        line-height: .88rem;
        background-color: #e7be84;
        border-radius: .44rem;
        font-family: PingFangSC-Medium;
        font-size: .32rem;
        color: #ffffff;
    }
    /*iPhone X XS 2436x1125px at 458ppi */
    @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        .lesson_loading{
            top: constant(safe-area-inset-top);
            top: env(safe-area-inset-top);
            i{
                top: calc(.2rem + constant(safe-area-inset-top))
            }
        }
    }

    /*iPhone XR 1792x828px at 326ppi */
    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
        .lesson_loading{
            top: constant(safe-area-inset-top);
            top: env(safe-area-inset-top);
            i{
                top: calc(.2rem + constant(safe-area-inset-top))
            }
        }
    }

    /* iPhone XS Max 2688x1242px at 458ppi */
    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
        .lesson_loading{
            top: constant(safe-area-inset-top);
            top: env(safe-area-inset-top);
            i{
                top: calc(.2rem + constant(safe-area-inset-top))
            }
        }
    }
</style>